import React, { useEffect, useRef } from "react";
import { PRESENTERS, drawPresenterThumb } from "../../video/presenters";

// A small portrait of a studio presenter (for the picker and the history).
export default function PresenterThumb({ id, size = 120, className = "" }) {
  const ref = useRef(null);
  useEffect(() => { if (ref.current && PRESENTERS[id]) drawPresenterThumb(ref.current, PRESENTERS[id]); }, [id]);
  return <canvas ref={ref} width={size} height={Math.round(size * 1.1)} className={`block ${className}`} role="img" aria-label={PRESENTERS[id]?.name || "Presenter"} />;
}
